export function formatDate(dateString: string): string {
  if (!dateString) return '';

  const [month, day, year] = dateString.split('/');
  const formattedMonth = month.padStart(2, '0');
  const formattedDay = day.padStart(2, '0');

  return `${year}-${formattedMonth}-${formattedDay}`;
}
